import { render, staticRenderFns } from "./inactivity.vue?vue&type=template&id=63999386"
import script from "./inactivity.vue?vue&type=script&lang=js"
export * from "./inactivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports